<template>
  <div>
    <Breadcrumbs main="Beacon" title="Annoucement" />

    <div class="container-fluid">
      <div class="d-flex justify-content-end m-3">
        <b-button variant="primary" class="btn-pill" @click="openModal('Add')">
          <i class="icofont icofont-plus-circle"></i> Add New</b-button>
      </div>

      <ValidationObserver v-slot="{ invalid }">
        <b-modal size="lg" ref="vuemodal" :hide-footer="modalData.title == 'View'" content-class="rounded-1"
          v-model="show" body-class="px-4 " centered :title="`${modalData.title} Annoucement`">
          <b-badge v-for="(item, i) in btnCode" :key="i" class="mx-1" variant="primary" pill style="cursor: pointer"
            @click="addCode(code, item.code)">{{ item.tip }}</b-badge>
          <div class="row mt-2">
            <div v-for="(form, i) in form" :key="i" :class="`col-${form.col}`">
              <ValidationProvider :name="form.name" :rules="form.validate ? form.rule : ''" v-slot="{ errors }">
                <b-form-group :label="form.name" :label-for="form.name">
                  <template #description>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </template>

                  <quill-editor id="quillEditor" :style="modalData.disable
                                      ? 'background-color:#e9ecef;font-family: Tahoma; font-size: 10px;'
                                      : ''
                                      " :class="modalData.disable ? 'headerDisable' : 'headerEnable'
                        " v-if="form.type.match('editor')" v-model="form.value" :disabled="modalData.disable" @focus="code = i"
                    :options="editorOption">
                  </quill-editor>

                  <b-form-textarea v-else-if="form.type.match('text-area')" v-model="form.value" rows="3" id="description"
                    @focus="code = i" :disabled="modalData.disable"></b-form-textarea>

                  <b-form-input v-else :disabled="modalData.disable" v-model="form.value" @focus="code = i"
                    :id="form.name"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
          </div>

          <template #modal-footer>
            <b-button variant="primary" @click="save(modalData)" :disabled="invalid"><i class="fa fa-save"></i> Save
            </b-button>
          </template>
        </b-modal>
      </ValidationObserver>

      <div class="card p-4">
        <dataTableVue ref="refDataTable" :isSearch="false" :isFilter="true" :isExport="true" v-bind:data="{
                  module: 'beacon',
                  columns: columns,
                  rows: rows,
                  exportDetail: exportDetail,
                  filter_col: [0, 4],
                  filter_custom: 'dynamicFilterVue',
                }" @load="loadItems" @openModal="openModal" @deleteRow="deleteRow" />
      </div>
    </div>
  </div>
</template>

<script>
import { requestService } from './../../_services';
import Quill from 'quill';
import ImageResize from 'quill-image-resize-vue';
Quill.register('modules/imageResize', ImageResize);

export default {
  data() {
    return {
      editorOption: {
        modules: {
          //imageDrop: true,
          // imagePaste: true,
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image', 'video'],
            ['template-partediario'],
          ],
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
          },
        },
      },
      btnCode: [
        {
          tip: 'Incident ID',
          code: 'INCxxxxxxx',
        },
        {
          tip: 'Application',
          code: 'AAAAA',
        },
        {
          tip: 'Category',
          code: 'GGGGG',
        },
        {
          tip: 'Symptom',
          code: 'SEEEE',
        },
        {
          tip: 'Symptom',
          code: 'STTTT',
        },
        {
          tip: 'Acknowledge Date',
          code: 'D1111',
        },
        {
          tip: 'Acknowledge Time',
          code: 'T1111',
        },
        {
          tip: 'Occurring Date',
          code: 'D2222',
        },
        {
          tip: 'Occurring Time',
          code: 'T2222',
        },
        {
          tip: 'Expected Resolving Date',
          code: 'D3333',
        },
        {
          tip: 'Expected Resolving Time',
          code: 'T3333',
        },
        {
          tip: 'Resolving Date',
          code: 'D4444',
        },
        {
          tip: 'Resolving Time',
          code: 'T4444',
        },
        {
          tip: 'Sender',
          code: 'UUUUU',
        },
      ],
      type: '',
      subject: '',
      description: '',
      message: '',
      modalData: {
        title: null,
        disable: false,
        row: null,
      },
      code: 1,
      show: false,
      form: [
        {
          value: '',
          col: 12,
          name: 'Type',
          type: 'input',
          validate: true,
          rule: 'required|customRegex|customRegexCRLF|max_length200'
        },
        {
          value: '',
          col: 12,
          name: 'E-mail Subject',
          type: 'input',
          validate: true,
          rule: 'required|customRegex|customRegexCRLF|max_length200'
        },
        // {
        //   value: '',
        //   col: 12,
        //   name: 'Description',
        //   type: 'text-area',
        // },
        {
          value: '',
          col: 12,
          name: 'E-mail Message',
          type: 'editor',
          validate: true,
          rule: 'required'
        },
        {
          value: '',
          col: 12,
          name: 'SMS Message',
          type: 'text-area',
          validate: true,
          rule: 'required|customRegex'
        },
      ],
      columns: [
        {
          label: 'Annocement Type',
          field: 'type',
          hidden: false,
          visible: true,
        },
        {
          label: 'Email Subject',
          field: 'email_subject',
          hidden: false,
          visible: true,
        },
        {
          label: 'Email Message',
          field: 'email_message',
          hidden: false,
          visible: true,
        },
        {
          label: 'SMS Message',
          field: 'sms_message',
          hidden: false,
          visible: true,
        },
        {
          label: 'Action',
          field: 'action',
          thClass: 'custom-th-class',
          hidden: false,
          visible: true,
        },
      ],
      rows: [],
      exportDetail: {
        fileName: 'export_announment',
        exportUrl: '',
      },
    };
  },
  watch: {
    show(newValue, oldValue) {
      if (oldValue) {
        this.form.map((item, i) => {
          this.form[i].value = '';
        });
      }
    },
  },
  mounted() {
    // this.loadColumn();
    setTimeout(() => this.loadItems(), 1000);
  },
  methods: {
    addCode(index, code) {
      this.form[index].value += code;
    },
    deleteRow(value) {
      const url = `/api/announcement/${value.row._id}`;
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            requestService
              .DeleteFetch('beacon', url)
              .then(() => {
                this.$swal.fire(
                  'Deleted!',
                  'Your file has been deleted.',
                  'success'
                );
                this.loadItems();
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    save(value) {
      let data = this.form.map((item) => item.value);
      this.show = !this.show;
      const url = `/api/announcement${value.title.match('Edit') ? '/' + value.row.row._id : ''
        }`;
      data[2] = data[2].replaceAll(' ', '&nbsp;');
      data[2] = data[2].replaceAll('\t', '&nbsp;&nbsp;&nbsp;&nbsp;');
      data[2] = data[2].replaceAll('<img&nbsp;', '<img ');
      data[2] = data[2].replaceAll('<strong&nbsp;', '<strong ');
      data[2] = data[2].replaceAll('<span&nbsp;', '<span ');
      data[2] = data[2].replaceAll('color:&nbsp;', 'color: ');

      data[2] = data[2].replaceAll('<p&nbsp;class=', '<p class=');
      data[2] = data[2].replaceAll('<p class="ql-indent-1">', '<p>&emsp;&emsp;');
      data[2] = data[2].replaceAll('<p class="ql-indent-2">', '<p>&emsp;&emsp;&emsp;');
      data[2] = data[2].replaceAll('<p class="ql-indent-3">', '<p>&emsp;&emsp;&emsp;&emsp;&emsp;');
      data[2] = data[2].replaceAll('<p class="ql-indent-4">', '<p>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;');
      data[2] = data[2].replaceAll('<p class="ql-indent-5">', '<p>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;');

      data[2] = data[2].replaceAll('<a&nbsp;href=', '<a href=');
      data[2] = data[2].replaceAll('&nbsp;rel=', ' rel=');
      data[2] = data[2].replaceAll('&nbsp;target=', ' target=');
      data[2] = this.replaceColor(data[2]);

      data[2] = data[2].replaceAll('<pre&nbsp;', '<pre ');
      data[2] = data[2].replaceAll('&nbsp;spellcheck=', ' style="background-color: #23241f;color: #f8f8f2;overflow: visible;" spellcheck=');
      data[2] = data[2].replaceAll('<p&nbsp;class=', '<p class=');
      data[2] = data[2].replaceAll('class="ql-align-right"', 'style="text-align: right;"');
      data[2] = data[2].replaceAll('class="ql-align-center"', 'style="text-align: center;"');
      data[2] = data[2].replaceAll('class="ql-align-justify"', 'style="text-align: justify;"');
      data[2] = data[2].replaceAll('class="ql-size-small"', 'style="font-size: 0.75em;"');
      data[2] = data[2].replaceAll('class="ql-size-large"', 'style="font-size: 1.5em;"');
      data[2] = data[2].replaceAll('class="ql-size-huge"', 'style="font-size: 2.5em;"');
      data[2] = data[2].replaceAll('noopener&nbsp;noreferrer', 'noopener noreferrer');

      data[2] = data[2].replaceAll(
        'style="cursor:&nbsp;nwse-resize;"',
        ' style="cursor: nwse-resize;"'
      );

      data[2] = data[2].replaceAll('&nbsp;width=', ' width=');
      const object = {
        type: data[0],
        email_subject: data[1],
        // description: data[2],
        email_message: data[2],
        sms_message: data[3],
      };

      requestService
        .PostFetch('beacon', url, object)
        .then(() => {
          this.$swal.fire({
            icon: 'success',
            title: 'Annoucement has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          this.form.map((item, i) => {
            this.form[i].value = '';
          });
          this.loadItems();
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
          });
        });
    },
    openModal(value, id) {
      this.modalData.title = value;
      this.modalData.row = id;
      this.show = !this.show;
      if (!value.match('Add')) {
        this.form[0].value = id.row.type;
        this.form[1].value = id.row.email_subject;
        this.form[2].value = id.row.email_message;
        this.form[3].value = id.row.sms_message;
      }
      value.match('View')
        ? (this.modalData.disable = true)
        : (this.modalData.disable = false);
    },
    loadItems(event) {
      var str = '';
      if (event != undefined) {
        for (var key in event.params) {
          if (str != '') {
            str += '&';
          }
          str += key + '=' + encodeURIComponent(event.params[key]);
        }
        this.columns.forEach((element) => {
          if (event.sortField == element.field) {
            if (
              event.sortField == 'created_at' ||
              event.sortField == 'updated_at'
            ) {
              str += '&' + 'sortField=' + event.sortField;
            } else {
              str += '&' + 'sortField=' + element.field;
            }
          }
        });
        if (event.filter != undefined) {
          for (var key in event.filter) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.filter[key]);
          }
        }
      }
      var url = '/api/announcement/filter?' + str;
      this.exportDetail.exportUrl = '/api/announcement/export?' + str;
      return requestService
        .GetFetch('beacon', url)
        .then((response) => {
          if (response.status == 200) {
            response.text().then((text) => {
              let self = this;
              self.rows = [];
              const data = text && JSON.parse(text);
              if (data.data.data != null) {
                self.json_data = data.data.data;
                self.rows = data.data.data;
                self.$refs.refDataTable.setTotalRecords(data.data.total);
                self.$refs.refDataTable.setPages(data.data.current_page);
              } else {
                self.$refs.refDataTable.setTotalRecords(0);
                self.$refs.refDataTable.setPages(1);
              }
            });
          }
        })
        .catch((error) => {
          this.$notify({ text: error, type: 'danger' });
        });
    },
    replaceColor(text) {
      var pos = 0;
      while (true) {
        let result = text.indexOf("rgb", pos);
        //console.log("result",result);
        if (result == -1) {
          break;
        }

        let result1 = text.indexOf(");", result);
        //console.log("result1",result1);

        const raw = text.substring(result, result1);
        //console.log("raw",raw,typeof raw);
        //const rawReplace = raw.toString().replaceAll("&nbsp;", "");
        const rawReplace = raw.split('&nbsp;').join('');
        //console.log("rawReplace",rawReplace);
        text = text.replace(raw, rawReplace);
        //console.log("text",text);
        let result2 = text.indexOf(rawReplace, pos);
        //console.log("result2",result2);
        //console.log("new location",result2+1);
        pos = result2 + 1;
      }
      //console.log("x",x);
      return text;
    },
  },
};
</script>

<style>
.headerDisable>.ql-toolbar {
  pointer-events: none;
}
</style>
